import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import { StyledDatePicker } from "./CustomDatePicker.styles";

const CustomDatePicker = ({ value, setValue, width, minDate = true }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <StyledDatePicker
      format="MM/DD/YYYY"
      minDate={minDate ? dayjs() : null}
      value={value}
      onChange={setValue}
      $width={width}
    />
  </LocalizationProvider>
);

export default CustomDatePicker;
